import React from 'react';

import Agreement from '../models/Agreement';
import { PopupState } from '../models/PopupState';
import IdentifyAgreement from './IdentifyAgreement';
import IdentifyMultiple from './IdentifyMultiple';
import IdentifySingle from './IdentifySingle';

const PopupComponent = ({
  agreementsTabIndex,
  onAgreementsPopupTabChange,
  onFeatureSelect,
  onPopupBack,
  onPopupClose,
  onRequestDocuments,
  popupState: { canGoBack, data, popupType }
}) => {
  switch (popupType) {
    case 'agreement':
      return (
        <IdentifyAgreement
          agreement={data}
          onBack={canGoBack ? onPopupBack : undefined}
          onClose={onPopupClose}
          onRequestDocuments={onRequestDocuments}
          onSetTab={onAgreementsPopupTabChange}
          tabIndex={agreementsTabIndex}
        />
      );

    case 'single':
      return (
        <IdentifySingle
          featureProps={data}
          onClose={onPopupClose}
          onBack={canGoBack ? onPopupBack : undefined}
        />
      );

    case 'multiple':
      return (
        <IdentifyMultiple
          features={data}
          onFeatureSelect={onFeatureSelect}
          onClose={onPopupClose}
        />
      );
    default:
      return null;
  }
};

export interface StateProps {
  isPopupLoading: boolean;
  popupState: PopupState | null;
  selectedAgreement: Agreement | null;
  selectedTableAgreementMapLocation: {
    popupAnchor: [number, number] | null;
    bounds: [number, number, number, number] | null;
  };
  agreementsTabIndex: number;
}

export interface DispatchProps {
  onAgreementsPopupTabChange: (index: number) => void;
  onFeatureSelect: (id: string) => void;
  onPopupBack: () => void;
  onPopupClose: () => void;
  onRequestDocuments: (agreementId: string) => void;
}

type Props = StateProps & DispatchProps;

export const IdentifyPopup: React.FC<Props> = ({
  agreementsTabIndex,
  onAgreementsPopupTabChange,
  onFeatureSelect,
  onPopupBack,
  onPopupClose,
  onRequestDocuments,
  popupState,
  isPopupLoading,
  selectedAgreement,
  selectedTableAgreementMapLocation: { bounds, popupAnchor }
}) => {
  if (isPopupLoading) {
    return null;
  }

  if (popupState) {
    return (
      <PopupComponent
        onFeatureSelect={onFeatureSelect}
        onPopupBack={onPopupBack}
        onPopupClose={onPopupClose}
        onRequestDocuments={onRequestDocuments}
        popupState={popupState}
        agreementsTabIndex={agreementsTabIndex}
        onAgreementsPopupTabChange={onAgreementsPopupTabChange}
      />
    );
  }

  if (selectedAgreement && popupAnchor && bounds) {
    return (
      <IdentifyAgreement
        agreement={selectedAgreement}
        onClose={onPopupClose}
        onRequestDocuments={onRequestDocuments}
        onSetTab={onAgreementsPopupTabChange}
        tabIndex={agreementsTabIndex}
      />
    );
  }

  if (selectedAgreement && !popupAnchor && !bounds) {
    return (
      <IdentifyAgreement
        agreement={selectedAgreement}
        onClose={onPopupClose}
        onRequestDocuments={onRequestDocuments}
        onSetTab={onAgreementsPopupTabChange}
        message="This agreement has not been mapped"
        tabIndex={agreementsTabIndex}
      />
    );
  }

  return null;
};

export default IdentifyPopup;
